import Cookies from "js-cookie";
import { Navigate } from "react-router-dom";

// Function to get the access token from cookies
export const getAccessToken = (cookie) => {
  return Cookies.get(cookie);
};

// Function to check if the user is authenticated
export const isAuthenticatedvalid = (cookie) => {
  let value = getAccessToken(cookie);
  if (
    value !== undefined &&
    value !== null &&
    value !== "" &&
    undefined !== "undefined"
  ) {
    return true;
  } else return false;
};

// Function to get the access token from cookies 1 * 60 * 1000
export const UpdateAccessToken = () => {
  //                 Min
  const inFifteenMinutes = new Date(new Date().getTime() + 10 * 60 * 1000);
  if (isAuthenticatedvalid("access")) {
    //console.log(Cookies.get("access"));
    let value = Cookies.get("access");
    if (
      value !== undefined &&
      value !== null &&
      value !== "" &&
      undefined !== "undefined"
    ) {
      Cookies.set("access", value, { expires: inFifteenMinutes });
    } else {
      Cookies.remove("access");
      Cookies.remove("usuario");
      Cookies.remove("tipoEmpleado");
      Cookies.remove("operador");
      Cookies.remove("ViDocPen");
      Cookies.remove("id");
      Cookies.remove("ViDocPen");
      return false;
    }

    value = Cookies.get("usuario");
    if (
      value !== undefined &&
      value !== null &&
      value !== "" &&
      undefined !== "undefined"
    ) {
      Cookies.set("usuario", value, { expires: inFifteenMinutes });
    } else {
      Cookies.remove("access");
      Cookies.remove("usuario");
      Cookies.remove("tipoEmpleado");
      Cookies.remove("operador");
      Cookies.remove("ViDocPen");
      Cookies.remove("id");
      Cookies.remove("ViDocPen");
      return false;
    }

    value = Cookies.get("tipoEmpleado");
    if (
      value !== undefined &&
      value !== null &&
      value !== "" &&
      undefined !== "undefined"
    ) {
      Cookies.set("tipoEmpleado", value, { expires: inFifteenMinutes });
    } else {
      Cookies.remove("access");
      Cookies.remove("usuario");
      Cookies.remove("tipoEmpleado");
      Cookies.remove("operador");
      Cookies.remove("ViDocPen");
      Cookies.remove("id");
      Cookies.remove("ViDocPen");
      return false;
    }

    value = Cookies.get("operador");
    if (
      value !== undefined &&
      value !== null &&
      value !== "" &&
      undefined !== "undefined"
    ) {
      Cookies.set("operador", value, { expires: inFifteenMinutes });
    } else {
      Cookies.remove("access");
      Cookies.remove("usuario");
      Cookies.remove("tipoEmpleado");
      Cookies.remove("operador");
      Cookies.remove("ViDocPen");
      Cookies.remove("id");
      Cookies.remove("ViDocPen");
      return false;
    }

    value = Cookies.get("id");
    if (
      value !== undefined &&
      value !== null &&
      value !== "" &&
      undefined !== "undefined"
    ) {
      Cookies.set("id", value, { expires: inFifteenMinutes });
    } else {
      Cookies.remove("access");
      Cookies.remove("usuario");
      Cookies.remove("tipoEmpleado");
      Cookies.remove("operador");
      Cookies.remove("ViDocPen");
      Cookies.remove("id");
      Cookies.remove("ViDocPen");
      return false;
    }

    value = Cookies.get("ViDocPen");
    if (
      value !== undefined &&
      value !== null &&
      value !== "" &&
      undefined !== "undefined"
    ) {
      Cookies.set("ViDocPen", value, { expires: inFifteenMinutes });
    } else {
      Cookies.remove("access");
      Cookies.remove("usuario");
      Cookies.remove("tipoEmpleado");
      Cookies.remove("operador");
      Cookies.remove("ViDocPen");
      Cookies.remove("id");
      Cookies.remove("ViDocPen");
      return false;
    }

    return true;
  } else {
    Cookies.remove("access");
    Cookies.remove("usuario");
    Cookies.remove("tipoEmpleado");
    Cookies.remove("operador");
    Cookies.remove("ViDocPen");
    Cookies.remove("id");
    Cookies.remove("ViDocPen");
    return false;
  }
};

export function AuthRoute({ children }) {
  const isAuthenticated = isAuthenticatedvalid("access");
  return isAuthenticated ? children : <Navigate to="/Home" children />;
}

export function PrivateRoute({ children }) {
  const isAuthenticated = isAuthenticatedvalid("access");
  return isAuthenticated ? children : <Navigate to="/" replace />;
}
